import React from 'react';
import styled from 'styled-components';

interface DividerProps {
  margin?: string;
}

// セクション間の区切り線
const StyledDivider = styled.div<{ $margin?: string }>`
  height: 1px;
  background-color: #e0e0e0;
  margin: ${props => props.$margin || '5px 0'};
  width: 100%;
`;

const Divider: React.FC<DividerProps> = ({ margin }) => {
  return <StyledDivider $margin={margin} />;
};

export default Divider; 